import axios from "axios";
import { useEffect, useState } from "react";

export default function ViewQuestion(props){

    const id =props.id;
    const [data, setData]=useState([]);

    function getData(id){
        axios.get(`${process.env.REACT_APP_BASE_URL}api/plan/secured/getPlan/`+id)
        .then(result=>setData(result.data))
        .catch(err=>console.log(err));
    }
    useEffect(()=>getData(id),[id]);

    return(<div className="container view-container">
          <button className="btn btn-danger" style={{float:"right"}} onClick={()=>props.event()}>X</button>
       <h2 className="text-center">View Plan</h2>
       <hr />
       <div className="row">
           <table className="table">
            <tbody>
                <tr>
                    <td>Plan Type</td>
                    <td>{data.planType || "N/A"}</td>
                </tr>
                <tr>
                    <td>Price</td>
                    <td>{data.price || "0"}</td>
                </tr>
                <tr>
                    <td>Passkey</td>
                    <td style={{color:"blue"}}>{data.passkey || "N/A"}</td>
       
                </tr>
                <tr>
                    <td>Created Date</td>
                    <td>{new Date(data.createdOn).toLocaleDateString("en-GB") || "N/A"}</td>
                </tr>
                <tr>
                    <td>Expired Date</td>
                    <td>{new Date(data.expiredDate).toLocaleDateString("en-GB") || "N/A"}</td>
                </tr>
                <tr>
                    <td>Status</td>
                    <td style={{color: data.status==="Active" ? "green" : "red",}}>{data.status || "N/A"}</td>
                </tr>
            </tbody>
           </table>
       </div>
       <div className="notice-board"><a style={{color:"red"}} href="https://softeasiest.linkpc.net/" target="_blank" rel="noopener noreferrer">*If status is pending contact to Admin!</a></div>
    </div>);
}